var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnnxNode } from '../../node';
export class PadNode extends OnnxNode {
    constructor(attributes, inputs, outputs, constants, onnxVersion, mode) {
        super(attributes, inputs, outputs, constants, onnxVersion, mode);
        this.padMode = (this.getAttributeString('mode') || 'constant');
        //@ts-ignore
        this.pads = this.getAttributeInts('pads');
        this.value = this.getAttributeFloat('value') || 0;
    }
    forward(inputs) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.onnxVersion < 11) {
                return [inputs[0].pad(this.pads, this.padMode, this.value)];
            }
            throw new Error(`Pad not implemented for onnx version ${this.onnxVersion}`);
        });
    }
    getType() {
        return 'Pad';
    }
    delete() { }
}
//# sourceMappingURL=pad.js.map